export const SET_LOADING = '[APP] SET_LOADING';

export const SET_REDEEMING = '[APP] SET_REDEEMING';